import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import IMAGES from "constants/images";
import TextInput from "components/TextInput";
import { Button, Card, Col, Container, Image, Row ,Spinner} from "react-bootstrap";
import RatingStars from "components/RatingStars";
import moment from "moment";
import { toast } from "react-toastify";
import { updateReviewDispute } from "api/ReviewService";
import ShowMoreText from "react-show-more-text";
import CollapsibleText from "components/CollapsibleText";

const DisputeComponent = ({ dispute, userId, fetchData }) => {
  const navigate = useNavigate();
  const [explanation, setExplanation] = useState("");
  const [updateLoading, setUpdateLoading] = useState(false);
  const handleUpdateDispute = async () => {
    try {
      if (explanation.trim() === "") {
        return toast.error("Please enter explaination");
      }
      setUpdateLoading(true);
      const payload = {
        explanation: explanation.trim(),
      };
      const res = await updateReviewDispute(payload, dispute?._id);
      if (res.success === true && res.code === 200) {
        toast.success(res.message);
        setExplanation("");
        fetchData();
      } else {
        toast.error(res.message);
      }
      setUpdateLoading(false);
    } catch (err) {
      setUpdateLoading(false);
      toast.error(err.message || "Something went wrong");
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { label: "Active", className: "badge-active" },
      pending: { label: "Pending", className: "badge-pending" },
      closed: { label: "Closed", className: "badge-closed" },
      resolved: { label: "Resolved", className: "badge-resolved" },
    };
    const { label, className } = statusConfig[status] || {
      label: status,
      className: "bg-secondary",
    };

    return <span className={`mx-2 badge ${className}`}>{label}</span>;
  };

  // console.log('userId === dispute?.reviewId?.userId', userId ,dispute?.reviewId?.userId.id)
  return (
    <div index={dispute?._id} className="r_Card mb-4">
      <div className="headerFLex">
        <h4>“{dispute?.reviewId?.title}”</h4>
        {userId === dispute?.reviewId?.userId && (
          <>
            <Button
              variant="info"
              className="border-radius-100 ms-auto me-3 hAnswers"
              onClick={() => {
                navigate("/write-a-review", {
                  state: { reviewId: dispute?.reviewId?._id },
                });
                const updatedChecked = [dispute?.productId];

                localStorage.setItem(
                  "checkedProducts",
                  JSON.stringify(updatedChecked)
                );
                localStorage.setItem("step", 3);
              }}
            >
              <Icon icon="lucide:edit" fontSize={16} className="me-2" />
              Edit Review
            </Button>
            <Button variant="danger" className="border-radius-100 hAnswers">
              <Icon icon="mi:delete" fontSize={17} className="me-2" />
              Delete Review
            </Button>
          </>
        )}
      </div>
      <p className="date_para">
        <RatingStars rating={Number(dispute?.reviewId?.overallRating)} />
        <span className="ms-1">{moment(dispute?.reviewId?.createdAt).format("LL")}</span>
      </p>
      <Card className="mb-0 border-0 pb-0">
        <Card.Body className="mb-0 ">
        <Card.Text className="para">
          <CollapsibleText lines={5}>
          <div dangerouslySetInnerHTML={{ __html: dispute?.reviewId?.review }} style={{whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem'}}></div>
          </CollapsibleText>
          </Card.Text>

          <h4 className="mb-3">Dispute</h4>
          <div className="userFlex mb-4" onClick={()=>navigate(`/product-details/${dispute?.productId?.slug}`)} style={{cursor: 'pointer'}}>
            <Image
              src={
                dispute?.productId?.logoUrl
                  ? dispute?.productId?.logoUrl
                  : IMAGES.Com1_IMG
              }
              alt=""
              style={{ height: '50px',width: '50px',objectFit: 'contain',background:dispute?.productId?.brandColors,padding: '5px',borderRadius: '5px'}}
              className="imgUser"
            />
            <div className="userGrow">
              <Card.Title>{dispute?.productId?.name}</Card.Title>
              <Card.Subtitle className="text-muted mb-0">
                {moment(dispute?.createdAt).format("LL")}
              </Card.Subtitle>
            </div>
          </div>
          <h5 style={{ textTransform: "capitalize" }}>
            {dispute?.reason}
            {getStatusBadge(dispute?.status)}
          </h5>
          <Card.Text className="mb-0" style={{ textTransform: "capitalize",whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem' }}>
            {dispute?.description}
          </Card.Text>
          {dispute?.explanation && (
            <div className="mt-3" style={{ textTransform: "capitalize" }}>
              <p className="mb-3">{`${dispute?.userId?.firstName} ${dispute?.userId?.lastName || ""}'s`} reply</p>
              {/* <ul> */}
                <p style={{whiteSpace: 'pre-wrap', lineHeight: '1.6', marginBottom: '1rem'}}>{dispute?.explanation}</p>
              {/* </ul> */}
            </div>
          )}
          {userId === dispute?.reviewId?.userId?.id && dispute?.status === "active" && (
            <div>
              <h4 className="my-3">{dispute?.explanation ? "Edit" : "Add"} Explanation</h4>
              <div className="coment_box_type" >
              <TextInput
              // labelText={"Description"}
              type="text"
              textarea="textarea"
              style={{height: '100%'}}
              value={explanation}
              placeholder={"Type here..."}
              onChange={(e) => setExplanation(e.target.value)}
              rows={6}
              maxLength={1000}
              // errorMessage="Description is required"
            />
               
                <Button
                  disabled={updateLoading}
                  onClick={handleUpdateDispute}
                  variant="info"
                  style={{width: '180px'}}
                  className="border-radius-100 px-5 d-flex justify-content-center align-items-center"
                >
                  {updateLoading ? <Spinner animation="border" size={'sm'}/> : "Submit"}
                </Button>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DisputeComponent;
